import { createRef as commonCreateRef } from "packages/react";

export const createRef = commonCreateRef;
